import { Outlet } from 'react-router-dom'
import { Copy, Eye } from 'iconoir-react'
import { PageScroll } from 'app/components/layout/PageScroll'
import { Button } from 'app/components/ui/button'
import { PageHeader } from 'app/components/ui/page-header'
import type { TabType } from 'app/components/Tabs'

export type AvailabilityLocationShadcnComponentProps = {
  title: string
  tabs: TabType[]
  onCopyPreview: () => void
  onCopyLink: () => void
}

export function AvailabilityLocationShadcnComponent({
  title,
  tabs,
  onCopyPreview,
  onCopyLink,
}: AvailabilityLocationShadcnComponentProps) {
  return (
    <PageScroll
      contentClassName="mt-2 flex flex-col pb-9"
      header={
        <PageHeader
          title={title}
          tabs={tabs}
          secondaryButtonSlot={
            <>
              <Button variant="tertiary" size="md" onClick={onCopyPreview}>
                <Eye /> Copy preview link
              </Button>
              <Button variant="tertiary" size="md" onClick={onCopyLink}>
                <Copy /> Copy scheduling link
              </Button>
            </>
          }
        />
      }
    >
      <Outlet />
    </PageScroll>
  )
}
